import { yup } from '@framework/validation';

export const TranslationKeysSchema = yup
  .array(
    yup
      .object({
        chiave: yup.string().label('Chiave').required(),
        valore: yup.string().label('Valore').required(),
      })
      .required()
      .noUnknown(),
  )
  .default([])
  .transform(v => (v === null ? [] : v))
  .label('Chiavi Traduzioni');

export type TranslationKeys = yup.InferType<typeof TranslationKeysSchema>;
